import { Component, ViewChild, OnInit } from '@angular/core';
import { IssuesModel } from './issues-model';
import * as ngswal from "sweetalert";
import { ApiMethod } from '../apimethods/api-method';
import { GlobalConstants } from '../common/global-constants';
import { customfunctions, DataParam } from '../common/customfunctions';
import { HttpClient, HttpXhrBackend } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import tableDragger from 'table-dragger';
import { ArticleinfoComponent } from '../articleinfo/articleinfo.component';
import { FileToUpload } from "../file-upload/file-to-upload.model";
import { NgForm, FormBuilder, FormGroup, Validators } from '@angular/forms';

declare var $;

@Component({
  selector: 'app-issues',
  templateUrl: './issues.component.html',
  styleUrls: ['./issues.component.css']
})
/** issues component*/
export class IssuesComponent implements OnInit {
  modelItem: IssuesModel = new IssuesModel();
  showCorrectionModal: boolean;
  showApprovalModal: boolean;
  fileBase64: string = "";
  filePath: any;
  files: string[] = [];
  @ViewChild('dataTableList', { static: false }) tableList;
  @ViewChild('dataTable', { static: false }) table;
  /*  @ViewChild('dataTableIssArticle', { static: false }) tableIssArticle;*/
  @ViewChild('trArticleList', { static: false }) rowArticle;
  loaded: boolean = false;
  queryissueId = null; unsaved = false;
  public lStatusList: any; filterStatus: string = 'All';
  popupButtonText: string;
  title: string;
  monthNo = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  date: Date = new Date();
  monthNameList = GlobalConstants.monthFullNames;
  popupCorrectionButtonText: string = 'Correction';
  popupApprovalButtonText: string = 'Approve With Correction';
  /** issues ctor */
  constructor(private route: ActivatedRoute, private fb: FormBuilder) {
    this.ResetFilter();
    this.loadGeneralmethod();
    this.modelItem.IssueConfig = null;
    this.loaded = false;
    this.modelItem.CurrentPagesAllotted = 0;
  }
  public checkIssueBackLogTab: boolean = GlobalConstants.CheckMetadataView('IssueBackLogTab');
  public checkUpdateIssueClosure: boolean = GlobalConstants.CheckMetadataView('Issue Details', true);
  public checkIssueViewFormat1: boolean = GlobalConstants.CheckMetadataView('IssueViewFormat1');

  ngOnInit(): void {
    try {
      this.route.queryParamMap.subscribe(params => {
        if (params.get("isId") != null) {
          this.queryissueId = params.get("isId");
        }
        if (params.get("type") != null) {
          let typeVal = GlobalConstants.GetTitleFormat(params.get("type"));
          $('#ddlStatus').val(typeVal).change();
        }
      });
      this.ResetLayout();
      $('.dropdown-item').click(function (e, val) {
        let htmlstr = $(this).html();
        if (htmlstr.indexOf('Issue') > 0) {
          $('#btnBacktoList').trigger("click");
        }
      });
      //setInterval(function () {
      //  if (localStorage.aEID != '0') {
      //    $('#btnEditIssue').trigger('click');
      //  }
      //}, 10000);
    } catch (e) {
      console.log(e);
    }

    this.dividerForm = this.fb.group({
      sectionPlacement: ['', Validators.required],
      contentType: ['', Validators.required],
      pages: ['', [Validators.required, Validators.min(1)]],
      contentDescription: ['', Validators.required]
    });

  }
  ngAfterViewChecked(): void {
    //Current Volume Pages Calculate
    this.FetchCurrentPages();

  }

  fileTypeChange(event) {
    try {


      this.unsaved = true;
      let ext = event.currentTarget.files[0].name.replace(/^.*\./, '');
      if (acceptext.indexOf('.') > -1) {
        var acceptext = $(event.currentTarget).attr('accept');
        if (acceptext.indexOf(ext) == -1) {
          ngswal("Warning !", "Invalid file format ! ", "warning");
          event.target.value = null;
          this.unsaved = false;
        }
      }
      let idVal = $(event.currentTarget).attr('id').replace('fileFmFu_', '');
      let uploadFileName = $('#fileName_' + idVal.toString()).text();
      if (event.currentTarget.files[0].name != uploadFileName) {
        ngswal({
          title: "File name not matched! ",
          text: "File name should be '" + uploadFileName + "'",
          type: "warning",
        });
        event.target.value = null;
        this.unsaved = false;
      }
    } catch (e) {
      console.log(e);
    }
  }


  //date Format
  formatDateColumn(dateL, format = '') {
    try {
      if (dateL == "" || dateL == null)
        return "";

      var date = new Date(dateL);
      var day = date.getDate();
      //var day = new Date(date.setDate(date.getDate() + days)).getDate();
      var dayString = day > 9 ? day : '0' + day;
      var Monthstr = this.monthNo[date.getMonth()] > 9 ? this.monthNo[date.getMonth()] : '0' + this.monthNo[date.getMonth()];
      var dtT = dayString + '-' + Monthstr + '-' + date.getFullYear(); //month_names[date.getMonth()]
      if (format = 'yyyy') {
        dtT = date.getFullYear() + '-' + Monthstr + '-' + dayString;
      }

      return dtT;
    } catch (e) {
      return "";
    }
  }


  ResetLayout(): void {
    customfunctions.SetTheme(localStorage.UserThemes, false);
    $('#divIssueMain').css('height', (GlobalConstants.size.height) - 260);
    //$('#divIssueArticleList').css('height', (GlobalConstants.size.height - 350));
  }

  tabledrag(): void {
    var el = document.getElementById('tblArticleList');
    var dragger = tableDragger(el, {
      mode: 'row',
      dragHandler: '',
      onlyBody: true,
      animation: 500
    });
    dragger.on('drop', function (from, to) {
      $("table#tblArticleList tbody").each(function (ind) {
        $(this).children().each(function (index) {
          $(this).find('td').first().html((index + 1).toString());
        });
      });
    });
  }
  callArticleLastRow() {
    if ($('.sindu_handle').length == 0)
      this.tabledrag();
  }


  //Load general function
  loadGeneralmethod() {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <IssuesModel>data["IssuePage"];
        this.LoadJournalList();

        $('.select2').select2({ dropdownParent: "#divFilterList" });

        $('#lstJournals').select2({
          placeholder: "Select Journals",
          dropdownParent: "#divFilterList"
        });
        $('#lstJournals').val([]).trigger('change');

        $('#ddlStatus').select2({
          placeholder: "Select Status",
          dropdownParent: "#divFilterList"
        });
        $('#ddlStatus').val([]).trigger('change');

        $('#lstVolume').select2({
          placeholder: "Select Volume",
          dropdownParent: "#divFilterList"
        });
        $('#lstVolume').val([]).trigger('change');

        $('#lstIssue').select2({
          placeholder: "Select Issue",
          dropdownParent: "#divFilterList"
        });

        $('#lstIssue').val([]).trigger('change');

      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  // Load Journal List
  LoadJournalList() {
    $("#LoadingImage").show();
    if (this.modelItem.JournalListAPI != '') {
      ApiMethod.getMethod(this.modelItem.JournalListAPI + '/' + localStorage.aPubID + '/' + localStorage.aLoginID).subscribe(
        result => {
          $("#LoadingImage").hide();
          this.modelItem.JournalList = JSON.parse(JSON.stringify(result.aJrnlList));
          this.modelItem.YearList = JSON.parse(JSON.stringify(result.aYearList));
          this.modelItem.IssueTypeList = JSON.parse(JSON.stringify(result.issueTypeList));

          if (this.queryissueId != null)
            this.LoadIssueDataList('Info');
          else
            this.LoadIssueDataList('List');

        },
        error => {
          $("#LoadingImage").hide();
          ngswal("Warning !", error.message, "warning");
        });
    }
  }

  getVolumeIssue() {

    var journals = $("#lstJournals").val().toString();
    ApiMethod.getMethod(this.modelItem.VolumeIssueListAPI + "/" + journals).subscribe(
      result => {
        this.modelItem.volumeList = result.volumeList;
        this.modelItem.issueList = result.issueList;

        $("#lstIssue").val(-1).trigger("change");
        $("#lstVolume").val(-1).trigger("change");

      }, error => {
        $("#LoadingImage").hide();
      });
  }

  GetDataByActiveTab(tabName) {
    this.LoadIssueDataList('List', tabName);

  }
  //Load Issues list master
  LoadIssueDataList(viewItem, loadType = '', autodataload = false) {
    if (autodataload == false) {
      $("#LoadingImage").show();
    }
    var journalList = null;
    if ($('#lstJournals').val() != null) {
      journalList = $('#lstJournals').val().toString()
    }
    var selectedStatus = $("#ddlStatus").val().toString();
    if (selectedStatus == "") {
      selectedStatus = 'All';
    }
    let filterLoadType = $('#TabulIssueList .active').attr('name');
    if (loadType != '') {
      filterLoadType = loadType;
    }

    var postData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      JournalId: 0,
      JournalList: journalList,
      Status: selectedStatus,

      Volume: $("#lstVolume option:selected").text(),
      Issue: $("#lstIssue option:selected").text(),
      LoadType: filterLoadType
    };
    ApiMethod.postMethod(this.modelItem.IssueMasterAPI, postData).subscribe(
      resonse => {
        this.modelItem.datasetList = JSON.stringify(resonse.aDataitem); // Data List
        this.modelItem.datasetList = JSON.parse(this.modelItem.datasetList);
        this.modelItem.dataTableList = $(this.tableList.nativeElement);

        if (this.lStatusList == null)
          this.lStatusList = resonse.issueStatusList;

        //Dynamic datable
        let acolList = resonse.aColList;

        let dataItem = new DataParam();
        dataItem.acolList = acolList;
        dataItem.aNewButtonName = 'btnEditIssue';
        dataItem.dataTable = this.modelItem.dataTableList;
        dataItem.dataset = this.modelItem.datasetList;
        dataItem.dtheight = (GlobalConstants.size.height - 320);
        dataItem.modulename = 'IssueListModule';
        dataItem.infoPopupID = 'ID';
        this.modelItem.dataTableArt = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#LoadingImage").hide();

        if (autodataload == false) {
          this.IssueViewAction(viewItem);

          if (this.queryissueId != null && viewItem != 'List') {
            this.LoadVolIssueData(this.queryissueId);
            this.IssueViewAction('IssueInfo');
          }
        }
      },
      error => {
        $("#LoadingImage").hide();
      }
    );
  }

  ResetDataListFilter() {
    $("#lstJournals").val(0).change();
    $('#ddlStatus').val("All").change();
    $("#lstIssue").val(-1).trigger("change");
    $("#lstVolume").val(-1).trigger("change");
    this.LoadIssueDataList('List');
  }

  IssueViewAction(viewTab) {
    if (this.unsaved) {
      ngswal({
        title: "Warning",
        text: "A change has been made in the page. Do you want to retain the change?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        closeOnConfirm: true,
        closeOnCancel: false
      },
        function (isConfirm) {
          if (isConfirm) {
            $('button.btnUploadIssueFiles').trigger('click');
          }
          else {
            ngswal.close();
          }
        });
    }
    if (viewTab == 'List') {
      $('#divIssueInfo').hide();
      $('#divIssueList').show();
    }
    else {
      $('#divIssueInfo').show();
      $('#divIssueList').hide();
    }
    this.unsaved = false;
  }

  // Load Issue Config List
  LoadIssueConfigList(issueId) {
    var dataItem = {
      PublisherId: localStorage.aPubID,
      IssueId: issueId
    };
    ApiMethod.postMethod(this.modelItem.IssueConfigAPI, dataItem).subscribe(
      resonse => {
        let IssueConfig = resonse.aIssueConfig;
        if (typeof IssueConfig == 'undefined') {
          this.modelItem.IssueConfig = null;
        }
        else {
          this.modelItem.IssueConfig = JSON.parse(JSON.stringify(IssueConfig));
        }
        $('#TxtIssueRemarks').val(IssueConfig.IssueRemarks);

        $('#thCurrent').html('Current Issue (' + IssueConfig.Journal + ' : ' + IssueConfig.Volume + '-' + IssueConfig.Issue + ')');
        $('#thOverAll').html('Current Volume (' + IssueConfig.Journal + ' : ' + IssueConfig.Volume + ')');

        this.ResetLayout();
      },
      error => {
        //console.error(error)

        ngswal("Error !", error, "warning");
      }
    );
  }

  //Reset filter
  ResetFilter(): void {
    //allocate issueId
    localStorage.IssueId = 0;
    this.modelItem.showIssueContentBody = false;
    this.modelItem.ProjectPlanList = null;
    this.modelItem.ApprovedArticleList = null;
  }

  LoadVolIssue(): void {
    if ($('#lstJournals').val() == 0 || $('#ddlYearList').val() == 0) {
      ngswal("Warning !", this.modelItem.VolIssueWarning, "warning");
    }

    else {
      this.ResetFilter();
      $("#LoadingImage").show();
      var userItem = {
        JournalId: $('#lstJournals').val(),
        Year: $('#ddlYearList').val()
      };
      ApiMethod.postMethod(this.modelItem.VolIssueList, userItem).subscribe(
        resonse => {
          $("#LoadingImage").hide();
          let IssueList = resonse.aIssueList;
          this.modelItem.VolumeIssueList = JSON.parse(JSON.stringify(IssueList));

          this.modelItem.ElementsList = JSON.parse(JSON.stringify(resonse.Elements));
          this.modelItem.FromMatterList = JSON.parse(JSON.stringify(resonse.FrontMatter));
          this.modelItem.BackMatterList = JSON.parse(JSON.stringify(resonse.BackMatter));

        },
        error => {
          //console.error(error)
          $("#LoadingImage").hide();
          ngswal("Error !", error, "warning");
        }
      );
    }
  }

  //Load Volume-Issue details
  LoadVolIssueData(itemId = "0"): void {
    if (localStorage.aEID == 0) {
      this.ShowIssueAdd();
    }
    else {
      let filterLoadType = $('#TabulIssueList .active').attr('name');
      if (filterLoadType == 'BacklogIssue') {
        ngswal("Warning !", "Unable to process Backlog Issue", "warning");
        return;
      }
      if (itemId == "0") {
        itemId = localStorage.aEID;
      }
      $('.VOLISS').removeClass('VOLISSActive');
      $('#btnVI' + itemId).addClass('VOLISSActive');
      $("table#tblArticleList tbody tr").remove();
      $("#LoadingImage").show();
      var dataItem = {
        PublisherId: localStorage.aPubID,
        IssueId: itemId
      };
      ApiMethod.postMethod(this.modelItem.ProjectPlanListAPI, dataItem).subscribe(
        resonse => {

          $("#LoadingImage").hide();
          let StageList = resonse.aStageList;

          this.modelItem.ProjectPlanList = JSON.parse(JSON.stringify(StageList));

          this.modelItem.checkIssueClouse = resonse.aPlanId;

          this.modelItem.ElementsList = JSON.parse(JSON.stringify(resonse.Elements));
          this.modelItem.FromMatterList = JSON.parse(JSON.stringify(resonse.FrontMatter));
          this.modelItem.BackMatterList = JSON.parse(JSON.stringify(resonse.BackMatter));

          //Fetch Issue Config details
          this.LoadIssueConfigList(itemId);
          //allocate issueId
          localStorage.IssueId = itemId;
          this.modelItem.showIssueContentBody = true;
          this.GetApproveArticleList();

          $('#thCurrent').html('Current Issue (' + $('#btnVI' + itemId).text() + ')');
          $('#thOverAll').html('Current Volume (' + $('#btnVI' + itemId).text().split('-')[0] + ')');
          this.IssueElementsCustomerApiComplete(0);
          this.ResetLayout();
        },
        error => {
          //console.error(error)
          $("#LoadingImage").hide();
          ngswal("Error !", error, "warning");
        }
      );
    }
  }

  FetchCurrentPages(): void {
    let currentPages = 0;
    let frontPages = $('[name="FmPages"]');
    let backPages = $('[name="BmPages"]');
    let artPages = $('[name="Pages"]');
    $.each(frontPages, function (e, item) {
      if ($(item).val().trim() != '')
        currentPages += parseInt($(item).val());
    });

    //$('#TxtIssueStartPage').attr('min', currentPages + 1);

    $.each(artPages, function (e, item) {
      if ($(item).val().trim() != '')
        currentPages += parseInt($(item).text());
    });
    $.each(backPages, function (e, item) {
      if ($(item).val().trim() != '')
        currentPages += parseInt($(item).val());
    });
    this.modelItem.CurrentPagesAllotted = (currentPages == null ? 0 : currentPages);


  }

  //Show popup articles list to Add articles to Issue
  ShowArticles() {
    if (localStorage.IssueId == 0) {
      ngswal("Warning !", this.modelItem.IssueIdSelectWarning, "warning");
    }
    else {
      this.modelItem.showAddArticle = true;
      this.GetApproveArticleList();
    }
    this.tabledrag();
  }

  //Hide Popup
  hide() {
    this.modelItem.showAddArticle = false;
    this.GetApproveArticleList();
  }

  dividerForm!: FormGroup;

  //Show popup articles list to Add articles to Issue
  ShowDivider() {
    this.dividerForm.reset();
    this.modelItem.showAddDivider = true;
  }
  HideDivider() {
    this.modelItem.showAddDivider = false;
  }

  AddDivider() {

    const { sectionPlacement, contentType, pages, contentDescription } = this.dividerForm.value;

    if (this.dividerForm.invalid) {
      this.dividerForm.markAllAsTouched(); // show errors
      return;
    }

    $("#LoadingImagePopup1").show();
    var postData = {
      LoginId: localStorage.aLoginID,
      IssueId: localStorage.IssueId,
      SectionPlacement: sectionPlacement,
      ContentType: contentType,
      Pages: pages,
      ContentDescription: contentDescription,
    };
    ApiMethod.postMethod(this.modelItem.UpdateIssueToArticle, postData).subscribe(
      resonse => {
        if (resonse.resultStatus == true) {
          this.dividerForm.reset();
          this.GetApproveArticleList();
          ngswal("Success !", resonse.resultMsg, "success");
        }
        else {
          ngswal("Warning !", resonse.resultMsg, "warning");
        }
        $("#LoadingImagePopup1").hide();
      },
      error => {
        $("#LoadingImagePopup1").hide();
        ngswal("Warning !", error.message, "warning");
      }
    );


  }

  //Fetch Approve articles list
  GetApproveArticleList(): void {
    $("#LoadingImagePopup").show();
    var postData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      JournalId: 0,
      IssueId: localStorage.IssueId
    };
    ApiMethod.postMethod(this.modelItem.ArticleListAPI, postData).subscribe(
      resonse => {

        this.modelItem.datasetArt = JSON.stringify(resonse.aDataitem); // Data List
        this.modelItem.datasetArt = JSON.parse(this.modelItem.datasetArt);
        this.modelItem.dataTableArt = $(this.table.nativeElement);


        //Dynamic datable - Unallocated Article List
        let acolList = resonse.aColList;

        let dataItem = new DataParam();
        dataItem.acolList = acolList;
        dataItem.aNewButtonName = '';
        dataItem.dataTable = this.modelItem.dataTableArt;
        dataItem.dataset = this.modelItem.datasetArt;
        dataItem.dtheight = (GlobalConstants.size.height - 220);
        dataItem.modulename = 'IssueConfigModule';
        dataItem.rowSelect = true;

        this.modelItem.dataTableArt = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable - Unallocated Article List



        let approveList = resonse.aDataApproveditem;
        this.modelItem.ApprovedArticleList = JSON.parse(JSON.stringify(approveList));

        //this.modelItem.datasetIssArt = JSON.stringify(resonse.aDataApproveditem); // Data List
        //this.modelItem.datasetIssArt = JSON.parse(this.modelItem.datasetIssArt);
        //this.modelItem.dataTableIssArt = $(this.tableIssArticle.nativeElement);

        //Dynamic datable - Allocated Article List

        //dataItem = new DataParam();
        //dataItem.acolList = acolList;
        //dataItem.aNewButtonName = '';
        //dataItem.dataTable = this.modelItem.dataTableIssArt;
        //dataItem.dataset = this.modelItem.datasetIssArt;
        //dataItem.dtheight = (GlobalConstants.size.height - 220);
        //dataItem.modulename = 'IssueConfigModule';
        //dataItem.rowSelect = false;

        //this.modelItem.dataTableIssArt = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable - Allocated Article List

        this.IssueViewAction('IssueInfo');
        $("#LoadingImagePopup").hide();
      },
      error => {
        $("#LoadingImagePopup").hide();
      }
    );

  }

  //Allocate Issue details to Articles
  AddArticletoIssue(): void {
    let articleSelect = $('table.dataTable tbody tr.selected');
    if (articleSelect.length == 0) {
      ngswal("Warning !", this.modelItem.ArticleAddSelectWarning, "warning");
    }
    else {
      let artIdList = [];
      $.each(articleSelect, function (e, val) {
        artIdList.push($(val).find('td')[0].innerText);
      });

      $("#LoadingImagePopup").show();
      var postData = {
        LoginId: localStorage.aLoginID,
        ArticleList: artIdList.toString(),
        IssueId: localStorage.IssueId,
        Allocatetype: 'Allocate'
      };
      ApiMethod.postMethod(this.modelItem.UpdateIssueToArticle, postData).subscribe(
        resonse => {
          if (resonse.resultStatus == true) {
            this.GetApproveArticleList();
            ngswal("Success !", resonse.resultMsg, "success");
          }
          else {
            ngswal("Warning !", resonse.resultMsg, "warning");
          }
          $("#LoadingImagePopup").hide();
        },
        error => {
          $("#LoadingImagePopup").hide();
          ngswal("Warning !", error.message, "warning");
        }
      );
    }
  }

  //Confirmation for Deallocate Issue details to Articles
  RemoveArticleFrom(artId, divider = false): void {
    ngswal({
      title: "Confirmation !",
      text: "Are you sure you want to remove the article?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          ngswal({
            title: 'Please wait processing!.....',
            text: '',
            showCancelButton: false,
            showConfirmButton: false
          });
          localStorage.aEID = artId;
          localStorage.divider = divider;
          $('#btnRemoveArticle').trigger("click");
        } else {
          ngswal("Cancelled", "Your Click cancel! :)", "warning");
        }
      }
    );
  }

  //Remove Article from Issue 
  RevertIssue(): void {
    $("#LoadingImage").show();
    var postData = {
      LoginId: localStorage.aLoginID,
      ArticleList: localStorage.aEID.toString(),
      IssueId: localStorage.IssueId,
      Allocatetype: 'Deallocate',
      IsDivider: localStorage.divider
    };
    ApiMethod.postMethod(this.modelItem.UpdateIssueToArticle, postData).subscribe(
      resonse => {
        if (resonse.resultStatus == true) {
          this.LoadVolIssueData(localStorage.IssueId);
          ngswal("Success !", resonse.resultMsg, "success");
        }
        else {
          ngswal("Warning !", resonse.resultMsg, "warning");
        }
        $("#LoadingImage").hide();
      },
      error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error.message, "warning");
      }
    );
  }

  // Restrict Strings char
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  // Add Elements 
  AddElements(groupName): void {
    if ($('.ApproveRow' + groupName).length != 0) {
      ngswal("Warning !", 'Please Approve Added ' + groupName + ' Matter Element !', "warning");
    }
    else {
      let tableName = '#tbl' + groupName + 'MatterList';
      let ddlelement = '';
      $.each(this.modelItem.ElementsList, function (e, val) {
        if (val.GroupName == groupName + ' Matter')
          ddlelement += "<option value='" + val.Pages + "'>" + val.Elements + "</option>";
      });

      let ApproveAction = '<i class="fa fa-check iIcon ApproveRow' + groupName + '" title="Approve Elements"></i>&nbsp;';
      let delAction = '<i class="fa fa-times iIcon DeleteRow' + groupName + '" title="Remove Elements"></i>';
      var nRowL = "<tr>";
      nRowL += '<td class="tdElement" style="padding:5px;border: 1px solid #ddd"><select class="ddl' + groupName + ' form-control select2"><option value="Select">Select</option>' + ddlelement + '</select></td></td>';
      nRowL += '<td style="padding:5px;border: 1px solid #ddd"><input type="file" name="fileupload" value="fileupload"/></td>';
      nRowL += '<td style="padding:5px;border: 1px solid #ddd"><input type="text" name="FmDescription" /></td>';
      nRowL += '<td style="padding:5px;border: 1px solid #ddd"><input type="text" name="FmPages" maxlength="3" (keypress)="numberOnly($event)"/></td>';

      if (this.checkIssueViewFormat1) {
        nRowL += `<td style="padding:5px;border: 1px solid #ddd"></td>`;
      }

      nRowL += '<td class="tdAction" style="padding:5px;border: 1px solid #ddd;cursor: pointer;font-size: 14px;text-align: center;">'
        + ApproveAction + delAction + '</td>';
      nRowL += "</tr>";
      $(tableName + ' tbody').append(nRowL);

      $('.ddl' + groupName).change(function () {
        if ($(this).val() == 'Select')
          $(this).parent().parent().find('[name="FmPages"]').val('');
        else
          $(this).parent().parent().find('[name="FmPages"]').val($(this).val());
      });
      $('.ApproveRow' + groupName).click(function () {
        let ddlClassName = '.ddl' + groupName;
        let elementVal = $(this).parent().parent().find(ddlClassName + ' option:selected').text();
        if (elementVal == 'Select') {
          ngswal("Warning !", 'Please Select ' + groupName + ' Matter Element !', "warning");
        }
        else {
          $(this).parent().parent().find('.tdElement').html(elementVal);
          $('.tdAction').html(delAction);
          $('.DeleteRow' + groupName).click(function () {
            $(this).closest("tr").remove();
          });
        }
      });

      $('.DeleteRow' + groupName).click(function () {
        $(this).closest("tr").remove();
      });
    }
  }

  RemoveElementsMatterRow(rowClass): void {
    $('.' + rowClass).click(function () {
      $(this).closest("tr").remove();
    });
  }

  //Issue Closure confirmation
  IssueClosureConfirm(): void {

    let taskList = $('#tblTaskList tbody tr').length;
    let approveFm_Wait = $('.ApproveRowFront').length;
    let approveBm_Wait = $('.ApproveRowBack').length;

    if (taskList == 0) {
      ngswal("Warning !", 'Workflow details not available !', "warning");
    }
    else if (approveFm_Wait > 0) {
      ngswal("Warning !", 'Please Approve Front Matter Element !', "warning");
    }
    else if (approveBm_Wait > 0) {
      ngswal("Warning !", 'Please Approve Back Matter Element !', "warning");
    }

    else {
      let getArticleList = GlobalConstants.GetTableRowToList('tblArticleList', null);
      let inprocessArticles = $('.trInprocess').length;
      let inProofPArticles = $('.trProofPage').length;
      let waitingPArticles = $('.trWaitingforPublish').length;

      if (getArticleList.length == 0) {
        ngswal("Warning !", "Article not available", "warning");
      }
      else if (inprocessArticles > 0) {
        ngswal("Warning !", 'Please check and approve all articles in this issue before closing the issue !', "warning");
      }
      else if (waitingPArticles > 0) {
        ngswal("Warning !", 'All Articles should be in Publish status in this issue before closing the issue !', "warning");
      }
      else if (inProofPArticles > 0) {
        ngswal("Warning !", 'Proof Page should not be zero for articles kindly check and update those and Close the Issue !', "warning");
      }
      else {
        let fileCount = 0;
        $.each($('[name="fileupload"]'), function (e, val) {
          fileCount += $(this)[0].files.length;
        })
        //if (fileCount != $('[name="fileupload"]').length) {
        //  //'Please upload files for added elements !'
        //  ngswal("Warning !", 'Issue elements not uploaded or saved after upload. Please check !', "warning");
        //}
        //else {
        ngswal({
          title: this.modelItem.IssueClosureConfirmTitle,
          text: this.modelItem.IssueClosureConfirmText,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes, Issue!",
          cancelButtonText: "No, cancel!",
          closeOnConfirm: false,
          closeOnCancel: false
        },
          function (isConfirm) {
            if (isConfirm) {
              $('#btnIssueCls').trigger("click");
            } else {
              ngswal("Cancelled", "Your Click cancel! :)", "warning");
            }
          }
        );
        //}
      }
    }
  }

  //Generate Issue Closure
  IssueClosure(): void {
    let approveFm_Wait = $('.ApproveRowFront').length;
    let approveBm_Wait = $('.ApproveRowBack').length;
    if (approveFm_Wait > 0) {
      ngswal("Warning !", 'Please Approve Front Matter Element !', "warning");
    }
    else if (approveBm_Wait > 0) {
      ngswal("Warning !", 'Please Approve Back Matter Element !', "warning");
    }
    else {
      // $("#LoadingImage").show();

      let getFrontMatter = GlobalConstants.GetTableRowToList('tblFrontMatterList', null);
      let getBackMatter = GlobalConstants.GetTableRowToList('tblBackMatterList', null);

      let getArticleList = GlobalConstants.GetTableRowToList('tblArticleList', null);
      let inprocessArticles = $('.trInprocess').length;
      if (getArticleList.length == 0) {
        ngswal("Warning !", "Article not available", "warning");
      }
      else if (inprocessArticles > 0) {
        ngswal("Warning !", '"' + inprocessArticles + '" - Articles not approved !', "warning");
      }
      else {
        var formData = new FormData($("#frmFiles")[0]);

        formData.append('ClientApiUrl', this.modelItem.IssueClosureAPI);
        formData.append('IssueId', localStorage.IssueId);
        formData.append('LoginId', localStorage.aLoginID);
        formData.append('PublisherId', localStorage.aPubID);
        formData.append('FrontMatter', JSON.stringify(getFrontMatter));
        formData.append('ArticleList', JSON.stringify(getArticleList));
        formData.append('BackMatter', JSON.stringify(getBackMatter));
        formData.append('IssueStartPage', $("#TxtIssueStartPage").val());

        ngswal({
          title: this.modelItem.IssueClosureProcessTitle,
          text: this.modelItem.IssueClosureProcessText,
          showCancelButton: false,
          showConfirmButton: false
        });

        let http = new HttpClient(new HttpXhrBackend({ build: () => new XMLHttpRequest() }));
        http.post<any>($('base')[0].href + 'api/Endpoint/PostFileListClient', formData).subscribe(
          response => {
            if (response != 'Issue Closure updated !') {
              ngswal("Failed!", response, "warning");
            }
            else {
              ngswal("Success !", "Issue closure updated !", "success");
              this.LoadVolIssueData(localStorage.IssueId);
            }
            $("#LoadingImage").hide();
          },
          error => {
            ngswal("Warning !", error.message, "warning");
            $("#LoadingImage").hide();
          });
      }
    }
  }

  //Download package activity
  DownloadPackage(activityid, flowId): void {
    ApiMethod.Downloadfile(this.modelItem.DownloadFileAPI + localStorage.IssueId + '/' + activityid + '/' + flowId + '/' + localStorage.aLoginID);
  }
  hideCorrectionModal() {
    this.showCorrectionModal = false;
  }
  hideAppCorrectionModal() {
    this.showApprovalModal = false;
  }

  PCCorrection(activityid, transId, downloadAction, correctionType = 'Correction'): void {
    let _typeSplit = correctionType.split('_');
    let _title = 'Further ' + correctionType;
    if (_typeSplit.length == 2) {
      _title = _typeSplit[0] + ' ' + _typeSplit[1];
      correctionType = _typeSplit[1];
    }

    $('.divHideCtrl').hide();
    $('#ddlCorrectionType').val(correctionType).change();
    $('#TxtIssueInstruction').val('');
    $('#Txt_IssueDueDate').val();
    $('div[name="correctionPopup"] input').val('');
    customfunctions.SetTodayDateValues("#Txt_IssueDueDate", 1);

    $('#divCtrl' + correctionType).show();
    $('#Txt_IssueUploadPages').val(0);
    $('#LblFileName').html(correctionType + ' file');
    $('#Lblh4CorrTitle').html(_title);
    this.popupCorrectionButtonText = correctionType;

    if ((transId == null || transId == 0) && downloadAction) {
      ngswal("Warning", "Please download the file to book a correction !", "warning");
    }
    else {
      localStorage.ActivityId = activityid;
      this.showCorrectionModal = true;
    }
  }
  ReopenIssue() {
    ngswal({
      title: "Do you want to Reopen the issue for Printer Booking?",
      text: "Issue Reopen Confirmation !",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          ngswal({
            title: 'Please wait processing!.....',
            text: '',
            showCancelButton: false,
            showConfirmButton: false
          });

          $('#LoadingImage').show();
          var aItemL = {
            LoginId: localStorage.aLoginID,
            IssueId: localStorage.aEID,
            ActivityId: localStorage.ActivityId,
          }
          ApiMethod.postMethod("issue/issueReopen", aItemL).subscribe(
            result => {
              $("#LoadingImage").hide();
              if (result.status != 'Failed') {
                ngswal("Info !", result.message, "success");
              } else {
                ngswal("Failed !", result.message.substr(0, 1000), "warning");
              }
              $('#btnEditIssue').trigger('click');
            }, error => {
              console.log(error);
              $("#LoadingImage").hide();
              ngswal("Failed !", error.message, "warning");
            });
          $('#LoadingImage').hide();


        } else {
          ngswal("Cancelled", "You clicked cancel! :)", "warning");
        }
      });
  }

  PCApproval(activityid, transId, downloadAction, ApproveAttachment, BlockApproval): void {
    localStorage.ActivityId = activityid;
    if ((transId == null || transId == 0) && downloadAction) {
      ngswal("Warning", "Please download the file to approve the issue !", "warning");
      $('#LoadingImage').hide();
    }
    else if (BlockApproval) {
      ngswal("Warning", "Issue Approval blocked due to some articles RTP is False !", "warning");
      $('#LoadingImage').hide();
    }
    else {
      if (ApproveAttachment) {
        $('#FU_ApproveAttchment').val('');
        this.showApprovalModal = true;
      }
      else {
        ngswal({
          title: "Do you want to approve the article for next stage?",
          text: "Issue Approval Confirmation !",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          closeOnConfirm: false,
          closeOnCancel: false
        },
          function (isConfirm) {
            if (isConfirm) {
              ngswal({
                title: 'Please wait processing!.....',
                text: '',
                showCancelButton: false,
                showConfirmButton: false
              });
              $('#btnIssueApprove').trigger("click");
            } else {
              ngswal("Cancelled", "You clicked cancel! :)", "warning");
            }
          });
      }
    }
  }

  approveConfirm() {
    $('#LoadingImage').show();
    let activityDate = null;
    console.log(document.getElementById('FU_IssueApproveAttchment'));
    let idInput = (<HTMLInputElement>document.getElementById('FU_IssueApproveAttchment')).files;
    var hrFileName = "";
    if (idInput.length > 0) {
      hrFileName = idInput[0].name;
    }
    if ($('input[name="CompletedDate"]').length > 0) {
      if ($('input[name="CompletedDate"]').val() != '') {
        activityDate = $('input[name="CompletedDate"]').val()
      }
    }
    var aItemL = {
      LoginId: localStorage.aLoginID,
      IssueId: localStorage.aEID,
      ActivityId: localStorage.ActivityId,
      ActivityComplete: activityDate,
      FileAsBase64: this.fileBase64,
      FileName: hrFileName,
    }
    ApiMethod.postMethod(this.modelItem.IssueApproveAPI, aItemL).subscribe(
      result => {
        console.log(result);
        if (this.showApprovalModal == true) {
          this.showApprovalModal = false;
        }
        $("#LoadingImage").hide();
        if (result.status != 'Failed') {
          ngswal("Info !", result.message, "success");
        } else {
          ngswal("Failed !", result.message.substr(0, 1000), "warning");
        }
        this.LoadJournalList();
      }, error => {
        console.log(error);
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });

    $('#LoadingImage').hide();
  }
  updateApprovalCorrection() {
    ngswal({
      title: "Do you want to approve the article for next stage?",
      text: "Issue Approval Confirmation !",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          ngswal({
            title: 'Please wait processing!.....',
            text: '',
            showCancelButton: false,
            showConfirmButton: false
          });
          $('#btnIssueApprove').trigger("click");
          this.showApprovalModal = false;
        } else {
          ngswal("Cancelled", "You clicked cancel! :)", "warning");
        }
      });
  }
  updateIssueCorrection() {
    let idInput = (<HTMLInputElement>document.getElementById('FU_IssueAttchment')).files;
    if ((idInput.length == 0) && ($('#TxtIssueInstruction').val().trim() == "")) {
      ngswal("Warning !", "Please enter instructions or upload a marked-up file to proceed with the correction !", "warning");
    }

    else {

      $("#LoadingImagePopup1").show();
      this.filePath = null;
      if (idInput.length > 0) {
        this.filePath = idInput.item[0];
      }
      let file = new FileToUpload();

      if (idInput.length > 0) {
        file.fileName = idInput[0].name;
        file.fileSize = idInput[0].size;
      }
      else {
        file.fileName = "";
        file.fileSize = 0;
      }
      file.vendorConfigID = localStorage.aEID;
      file.loginID = localStorage.aLoginID;
      file.publisherID = localStorage.aPubID;
      file.processType = $('#ddlCorrectionType').val();
      file.id = localStorage.aEID;
      file.entryType = "";
      file.instruction = $('#TxtIssueInstruction').val().trim();
      file.dueDate = $('#Txt_IssueDueDate').val();
      file.fileAsBase64 = this.fileBase64;
      file.ProcessId = localStorage.ActivityId;
      file.Pages = $('#Txt_IssueUploadPages').val();
      ngswal({
        title: 'Please wait processing!.....',
        text: '',
        showCancelButton: false,
        showConfirmButton: false
      });
      ApiMethod.postMethod(this.modelItem.UpdateIssueCorrectionAPI, file).subscribe(
        resonse => {
          $("#myModal_Corrections").hide();
          if (resonse.status == "Failed") {
            ngswal({
              position: "top-end",
              type: "error",
              title: "Error!",
              text: resonse.message,
              showConfirmButton: false,
              timer: 1500
            });
          }
          else {
            ngswal({
              position: "top-end",
              type: "success",
              title: "Uploaded!",
              text: resonse.message,
              showConfirmButton: false,
              timer: 1500
            });
          }
          this.hideCorrectionModal();
          this.LoadJournalList();
          $("#LoadingImagePopup1").hide();
        },
        error => {
          ngswal("Failed !", error.error.Message, "warning");
          $("#LoadingImagePopup1").hide();
        }
      );

    }
  }
  fileChangeEvent(fileInput: any) {

    if (fileInput.currentTarget.files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        this.fileBase64 = e.currentTarget.result;
      }
      fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
    }
  }
  ApproveFileChangeEvent(fileInput: any) {
    if (fileInput.currentTarget.files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        this.fileBase64 = e.currentTarget.result;
      }
      fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
    }
  }
  showArticleMetaAndInfo(artId) {
    localStorage.aEID = artId;
    $('#btnPopupartMeta').trigger('click');
  }

  RemoveIssueFileConfim(closureId): void {
    ngswal({
      title: "Are you sure to remove issue file?",
      text: "Remove File Confirmation !",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          localStorage.iscid = closureId;
          ngswal({
            title: 'Please wait processing!.....',
            text: '',
            showCancelButton: false,
            showConfirmButton: false
          });
          $('button.btnRemoveIssueFile').trigger("click");
        } else {
          ngswal("Cancelled", "Your Click cancel! :)", "warning");
        }
      }
    );
  }

  //Remove issue files
  RemoveIssueFile(): void {
    $("#LoadingImage").show();
    var postData = {
      LoginId: localStorage.aLoginID,
      IssueId: localStorage.IssueId,
      IssueClosureId: localStorage.iscid
    };
    ApiMethod.postMethod(this.modelItem.RemoveIssueFileAPI, postData).subscribe(
      resonse => {
        if (resonse.resultStatus == true) {
          this.LoadVolIssueData(localStorage.IssueId);
          ngswal("Success !", resonse.resultMsg, "success");
        }
        else {
          ngswal("Warning !", resonse.resultMsg, "warning");
        }
        localStorage.removeItem("iscid");
        $("#LoadingImage").hide();
      },
      error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error.message, "warning");
      }
    );
  }

  //Download IssueFiles
  DownloadIssueFile(closureId): void {
    ApiMethod.Downloadfile(this.modelItem.DownloadIssueFileAPI + localStorage.IssueId + '/' + closureId);
  }

  //Save Issue Upload files
  UploadIssueFiles(): void {
    if ($('[name="fileupload"]').length == 0) {
      ngswal("Warning !", 'No files to upload !', "warning");
    }
    else {
      let approveFm_Wait = $('.ApproveRowFront').length;
      let approveBm_Wait = $('.ApproveRowBack').length;
      if (approveFm_Wait > 0) {
        ngswal("Warning !", 'Please Approve Front Matter Element !', "warning");
      }
      else if (approveBm_Wait > 0) {
        ngswal("Warning !", 'Please Approve Back Matter Element !', "warning");
      }
      else {
        let getFrontMatter = GlobalConstants.GetTableRowToList('tblFrontMatterList', null);
        let getBackMatter = GlobalConstants.GetTableRowToList('tblBackMatterList', null);

        let getArticleList = GlobalConstants.GetTableRowToList('tblArticleList', null);

        let fileCount = 0;
        $.each($('[name="fileupload"]'), function (e, val) {
          fileCount += $(this)[0].files.length;
        })

        //if (fileCount == 0 && $('[name="fileupload"]').length > 0) {
        //  ngswal("Warning !", '"' + 'Please upload files for added elements !', "warning");
        //}
        //else {
        this.unsaved = false;
        var formData = new FormData($("#frmFiles")[0]);

        formData.append('ClientApiUrl', this.modelItem.UplodIssueFilesAPI);
        formData.append('IssueId', localStorage.IssueId);
        formData.append('LoginId', localStorage.aLoginID);
        formData.append('PublisherId', localStorage.aPubID);
        formData.append('FrontMatter', JSON.stringify(getFrontMatter));
        formData.append('ArticleList', JSON.stringify(getArticleList));
        formData.append('BackMatter', JSON.stringify(getBackMatter));
        formData.append('IssueStartPage', $("#TxtIssueStartPage").val());

        $("#LoadingImage").show();

        let http = new HttpClient(new HttpXhrBackend({ build: () => new XMLHttpRequest() }));
        http.post($('base')[0].href + 'api/Endpoint/PostFileListClient', formData).subscribe(
          response => {
            ngswal("Success !", "Issue files uploaded successfully !", "success");
            this.LoadVolIssueData(localStorage.IssueId);
            $("#LoadingImage").hide();
          },
          error => {
            ngswal("Warning !", error.message, "warning");
            $("#LoadingImage").hide();
          });

        //}

      }
    }

  }

  //Save Article Display Order
  SaveIssueLineupOrder(): void {

    let _startPages = 0;
    const val = $("#TxtIssueStartPage").val();
    if (val !== '') {
      _startPages += Number(val);   // or parseInt(val, 10)
    }

    let getArticleList = GlobalConstants.GetTableRowToList('tblArticleList', null);
    if (getArticleList.length == 0) {
      ngswal("Warning !", "Article not available", "warning");
    }
    else {
      var dataItem = {
        IssueId: localStorage.aEID,
        LoginId: localStorage.aLoginID,
        ArticleList: JSON.stringify(getArticleList),
        StartPageNo: _startPages
      }
      ApiMethod.postMethod(this.modelItem.SaveIssueLineupOrderApi, dataItem).subscribe(
        result => {
          $("#LoadingImagePopup").hide();
          if (result.resultStatus == false) {
            ngswal("Update Status", result.resultMsg, "warning");
          }
          else {
            ngswal("Update Status", result.resultMsg, "info");
          }
          this.GetApproveArticleList();
        },
        error => {
          $("#LoadingImagePopup").hide();
          try {
            ngswal("Warning !", error.error.Message, "warning");
          } catch (e) {
            ngswal("Warning !", error.Message, "warning");
          }
        }
      );
    }

  }

  showModal: boolean;
  ShowIssueAdd(): void {
    this.showModal = true;
    this.resetForm();
    if (localStorage.aEID != 0) {
      $("#LoadingImagePopup").show();
      console.log(this.modelItem.IssueByIDAPI);
      ApiMethod.getMethod(this.modelItem.IssueByIDAPI + '/' + localStorage.aEID).subscribe(
        result => {
          $("#LoadingImagePopup").hide();
          let aitems = result.itemResult;
          console.log(aitems);
          $('#ddlJournals').val(aitems[0].JournalID).change();
          if (aitems[0].IssueTypeId != null) {
            $('#ddlIssueType').val(aitems[0].IssueTypeId).change();
          }
          else {
            $('#ddlIssueType').append('<option value="' + null + '"disabled selected hidden>' + "Regular issue" + '</option>');
          }
          $('#TxtIssueYear').val(aitems[0].IssueYear);

          if (aitems[0].IssueMonth != null) {
            $('#ddlIssueMonth').val(aitems[0].IssueMonth).change();
          }

          $('#TxtVolume').val(aitems[0].Volume);
          $('#TxtIssue').val(aitems[0].Issue);
          $('#TxtIssueTitle').val(aitems[0].IssueTitle);
          if (aitems[0].LastManuscriptEntry != null) {
            $("#datelastmanuscript").val(GlobalConstants.SetValue_FormatDate(aitems[0].LastManuscriptEntry));
          }
          if (aitems[0].IssueMakeup != null) {
            $("#dateissuemakeup").val(GlobalConstants.SetValue_FormatDate(aitems[0].IssueMakeup));
          }
          $('#ddlNewCoverAdded').val(aitems[0].NewCoverNeeded == null ? 'false' : 'true').change();

          this.title = "Update Issue";
          this.popupButtonText = "Update";
        },
        error => {
          ngswal("Failed !", error.error.Message, "warning");
        }
      );

    } else this.popupButtonText = "Save";
    this.title = "Add Issue";

  }

  hideIssueAdd(): void {
    this.showModal = false;
  }

  AddIssueDetails(): void {
    if ($('#ddlJournals').val() == 0) {
      //'Please enter first name or last name ! '
      ngswal("Warning!", 'Please select Journal !', "warning");
    }
    else if ($('#ddlIssueType').val() == 0) {
      //'Please enter first name or last name ! '
      ngswal("Warning!", 'Please select Issue Type !', "warning");
    }
    else if ($('#TxtIssueYear').val() == 0 || $('#TxtIssueYear').val() == '') {
      //'Please enter first name or last name ! '
      ngswal("Warning!", 'Enter Issue year !', "warning");
    }
    else if ($('#ddlIssueMonth').val() == 0) {
      //'Please enter first name or last name ! '
      ngswal("Warning!", 'Select Issue Month !', "warning");
    }
    else if ($('#TxtVolume').val() == 0 || $('#TxtVolume').val() == '') {
      //'Please enter first name or last name ! '
      ngswal("Warning!", 'Enter Volume !', "warning");
    }
    else if ($('#TxtIssue').val() == 0 || $('#TxtIssue').val() == '') {
      //'Please enter first name or last name ! '
      ngswal("Warning!", 'Enter Issue !', "warning");
    }
    else {
      var dataItem = {
        ID: localStorage.aEID,
        JournalID: $('#ddlJournals').val(),
        IssueTypeId: $('#ddlIssueType').val(),
        IssueYear: $('#TxtIssueYear').val(),
        IssueMonth: $('#ddlIssueMonth').val(),
        Volume: $('#TxtVolume').val(),
        Issue: $('#TxtIssue').val(),
        IssueTitle: $('#TxtIssueTitle').val(),
        LastManuscriptEntry: $('#datelastmanuscript').val(),
        IssueMakeup: $('#dateissuemakeup').val(),
        NewCoverNeeded: $('#ddlNewCoverNeeded').val() == 'false' ? 0 : 1,
        UpdatedBy: localStorage.aLoginID

      }
      ApiMethod.postMethod(this.modelItem.AddIssueDetailsAPI, dataItem).subscribe(
        result => {
          $("#LoadingImagePopup").hide();
          if (result.resultStatus == false) {
            ngswal("Update Status", result.resultMsg, "warning");
          }
          else {
            ngswal("Update Status", result.resultMsg, "info");
            this.LoadIssueDataList('List');
            this.hideIssueAdd();
          }
        },
        error => {
          $("#LoadingImagePopup").hide();
          try {
            ngswal("Warning !", error.error.Message, "warning");
          } catch (e) {
            ngswal("Warning !", error.Message, "warning");
          }
        }
      );
    }
  }

  resetForm() {
    let form: NgForm = $('form');
    form[0].reset();
    $('form input').val('');
    $('#ddlIssueType,#ddlJournals').val(0).trigger('change');
  }

  UpdateCompletedDate(activityid): void {
    let completeDate = $('#TxtCompletedDate' + activityid).val();
    if (completeDate == '') {
      ngswal("Warning", "Please Select the CompletedDate to Update!", "warning");
    }
    else {
      $("#LoadingImagePopup").show();
      var dataItem = {
        LoginId: localStorage.aLoginID,
        PublisherId: localStorage.aPubID,
        IssueId: localStorage.IssueId,
        ActivityId: activityid,
        ActivityComplete: completeDate
      }
      ngswal({
        title: 'Please wait processing!.....',
        text: '',
        showCancelButton: false,
        showConfirmButton: false
      });
      ApiMethod.postMethod(this.modelItem.UpdateIssueActivityDateAPI, dataItem).subscribe(
        result => {
          $("#LoadingImagePopup").hide();
          if (result.resultStatus == false) {
            ngswal("Update Status", result.resultMsg, "warning");
          }
          else {
            ngswal("Update Status", result.resultMsg, "info");
          }
          this.LoadIssueDataList('Info', '', true);
          $('#btnEditIssue').trigger('click');
        },
        error => {
          $("#LoadingImagePopup").hide();
          try {
            ngswal("Warning !", error.error.Message, "warning");
          } catch (e) {
            ngswal("Warning !", error.Message, "warning");
          }
        }
      );
    }

  }

  UpdateIssueRemarks(): void {
    if ($('#TxtIssueRemarks').val().trim() == '') {
      //'Please enter first name or last name ! '
      ngswal("Warning!", 'Please Enter Issue Remakrs!', "warning");
    }
    else {
      var dataItem = {
        IssueId: localStorage.aEID,
        Remarks: $('#TxtIssueRemarks').val(),
        LoginId: localStorage.aLoginID
      }
      ApiMethod.postMethod(this.modelItem.UpdateIssueRemarksApi, dataItem).subscribe(
        result => {
          $("#LoadingImagePopup").hide();
          if (result.resultStatus == false) {
            ngswal("Update Status", result.resultMsg, "warning");
          }
          else {
            ngswal("Update Status", result.resultMsg, "info");
          }
          $('#btnEditIssue').trigger('click');
        },
        error => {
          $("#LoadingImagePopup").hide();
          try {
            ngswal("Warning !", error.error.Message, "warning");
          } catch (e) {
            ngswal("Warning !", error.Message, "warning");
          }
        }
      );
    }
  }

  showIssueScheduleModal: boolean;
  showIssueCompleteModal: boolean;
  issueRows: any = [];
  issueCRows: any = [];
  resources: any = [];

  hideIssueSchedule() {
    this.showIssueScheduleModal = false;
  }
  IssueElementsCustomerApi() {
    var dataItem = {
      PublisherId: localStorage.aPubID,
      JournalId: 0,
      IssueId: localStorage.IssueId
    };

    ApiMethod.postMethod('issue/issueelementcustomerapi', dataItem).subscribe(
      result => {

        $("#LoadingImagePopup").hide();

        this.issueRows = result.dataList || [];

        // build resource list from API rows
        const names = this.issueRows
          .map(x => x.JournalColumnValue)
          .filter(x => !!x);

        this.resources = Array.from(new Set(names));

        this.showIssueScheduleModal = true;
      },
      error => {
        $("#LoadingImagePopup").hide();
        try {
          ngswal("Warning !", error.error.Message, "warning");
        } catch (e) {
          ngswal("Warning !", error.Message, "warning");
        }
      }
    );

  }

  AddIssueSchedule() {

    $("#LoadingImage").show();
    var postData = {
      IssueId: localStorage.IssueId,
      UpdatedBy: localStorage.aLoginID,
      ElementList: this.issueRows
    };
    ApiMethod.postMethod('issue/updateissueelementcustomerapi', postData).subscribe(
      resonse => {
        if (resonse.status) {
          ngswal("Updated !", resonse.message, "info");
        }
        else {
          ngswal("Failed !", resonse.message, "warning");
        }

        $("#LoadingImage").hide();
      },
      error => {
        $("#LoadingImage").hide();
      }
    );
  }

  IssueElementsCustomerApiComplete(FromBtn = 1) {

    var dataItem = {

      PublisherId: localStorage.aPubID,

      JournalId: 0,

      IssueId: localStorage.IssueId

    };

    ApiMethod.postMethod('issue/issueelementcustomerapiComplete', dataItem).subscribe(

      result => {

        $("#LoadingImagePopup").hide();

        this.issueCRows = result.dataList || [];

        this.modelItem.checkIssueAPIComplete = 0;
        // build resource list from API rows
        if (this.issueCRows.length > 0) {
          this.modelItem.checkIssueAPIComplete = 1;
        }
        const names = this.issueCRows

          .map(x => x.JournalColumnValue)

          .filter(x => !!x);

        this.resources = Array.from(new Set(names));

        if (FromBtn == 1) {
          this.showIssueCompleteModal = true;
        }
      },

      error => {

        $("#LoadingImagePopup").hide();

        try {

          ngswal("Warning !", error.error.Message, "warning");

        } catch (e) {

          ngswal("Warning !", error.Message, "warning");

        }

      }

    );

  }

  CompleteIssueTask() {

    $("#LoadingImage").show();

    var postData = {
      IssueId: localStorage.IssueId,
      UpdatedBy: localStorage.aLoginID,
      ElementListComplete: this.issueCRows
    };

    ApiMethod.postMethod('issue/Closeissueelementcustomerapi', postData).subscribe(
      resonse => {
        if (resonse.status) {
          ngswal("Updated !", resonse.message, "info");
        }
        else {
          ngswal("Failed !", resonse.message, "warning");
        }
        $("#LoadingImage").hide();

      },

      error => {
        $("#LoadingImage").hide();
      }

    );

  }

  hideIssuecomplete() {
    this.showIssueCompleteModal = false;
  }


  showIssueHistoryModal: boolean;
  issueHRows: any = [];
  hideIssueHistory() {
    this.showIssueHistoryModal = false;
  }

  IssueAPIHistory() {
    var dataItem = {
      PublisherId: localStorage.aPubID,
      JournalId: 0,
      IssueId: localStorage.IssueId
    };

    ApiMethod.postMethod('issue/issuecustomerapiHistory', dataItem).subscribe(

      result => {
        $("#LoadingImagePopup").hide();

        this.issueHRows = result.dataList || [];

        // build resource list from API rows

        this.showIssueHistoryModal = true;
      },
      error => {
        $("#LoadingImagePopup").hide();
        try {
          ngswal("Warning !", error.error.Message, "warning");
        }
        catch (e) {
          ngswal("Warning !", error.Message, "warning");
        }
      }
    );
  }


  DownloadTOCFile(): void {
    const issueId = localStorage.getItem('IssueId');
    ApiMethod.Downloadfile(
      `issue/DownloadTOCFile/${issueId}`
    );
  }
}


